module.exports = __webpack_public_path__ + "media/components/lesson1/statics/chatBody-9cf4af542862875b440548726b4bf8d7.png";